import { Button, Col, Form, Row } from "react-bootstrap";
import BackButton from "../../components/button/BackButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Typography } from "../../components/utilities/Typhograpy";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import SelectPersonnel from "../../components/select/SelectPersonnel";
import GlobalContext from "../../context/GlobalContext";
import { useContext, useEffect } from "react";
import swal from "../../services/swalConfig";
import { createHoliday, updateHoliday } from "../../api/HolidayApi";
import { useLocation } from "react-router-dom";

import { tr } from "../../i18n";
const HolidayForm = () => {
  const { state } = useLocation();
  const holiday = state;
  const { user, setLoading } = useContext(GlobalContext);
  const isEdit = Boolean(holiday?.id);

  console.log(holiday);

  const methods = useForm({
    defaultValues: {
      event: "",
      date_from: format(new Date(), "yyyy-MM-dd"),
      date_to: format(new Date(), "yyyy-MM-dd"),
      exceptions: null,
      reduce_paid_leave: false,
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = methods;

  // jika edit, set data awal
  useEffect(() => {
    if (holiday) {
      reset({
        event: holiday.event || "",
        date_from: holiday.date_from || format(new Date(), "yyyy-MM-dd"),
        date_to: holiday.date_to || format(new Date(), "yyyy-MM-dd"),
        exceptions: holiday.exceptions || null,
        reduce_paid_leave: holiday.reduce_paid_leave || false,
      });
    }
  }, [holiday, reset]);

  const onSubmit = handleSubmit(async (data) => {
    setLoading(true);
    try {
      const payload = {
        ...data,
        company_id: user.workspace.company_id,
        holiday_id: isEdit && holiday.id,
      };

      let response;
      if (isEdit) {
        response = await updateHoliday(payload);
      } else {
        response = await createHoliday(payload);
      }

      if (response.status === 200) {
        if (!isEdit) reset();
      }

      swal.fire({
        title: response.status === 200 ? tr("shared:success") : tr("common:errors.oops"),
        text: response.message,
        icon: response.status === 200 ? "success" : "error",
      });
    } catch (error) {
      swal.fire({
        title: tr("common:errors.oops"),
        text: tr("common:errors.generic"),
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  });

  return (
    <Row>
      <Col lg={7}>
        <div className="box-shadow">
          <FormProvider {...methods}>
            <Form onSubmit={onSubmit}>
              {/* Event */}
              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm="3">
                  <Typography variant="form">
                    {tr("attendance:event")}{" "} <span className="text-danger">*</span>
                  </Typography>
                </Form.Label>
                <Col sm="9">
                  <Form.Control
                    {...register("event", { required: tr("attendance:event_is_required") })}
                    type="text"
                    placeholder={tr("attendance:e_g_independence_day")}
                  />
                  {errors.event && (
                    <small className="text-danger">
                      {errors.event.message}
                    </small>
                  )}
                </Col>
              </Form.Group>

              {/* Date */}
              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm="3">
                  <Typography variant="form">
                    {tr("attendance:date")}{" "} <span className="text-danger">*</span>
                  </Typography>
                </Form.Label>
                <Col sm="9">
                  <Row>
                    <Col>
                      <input
                        {...register("date_from", {
                          required: tr("attendance:date_is_required"),
                        })}
                        type="date"
                        className="form-control"
                      />
                      {errors.date_from && (
                        <small className="text-danger">
                          {errors.date_from.message}
                        </small>
                      )}
                    </Col>
                    <Col>
                      <input
                        {...register("date_to", {
                          required: tr("attendance:date_is_required"),
                        })}
                        type="date"
                        className="form-control"
                      />
                      {errors.date_to && (
                        <small className="text-danger">
                          {errors.date_to.message}
                        </small>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Form.Group>

              {/* Exceptions */}
              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm="3">
                  <Typography variant="form">{tr("attendance:exceptions")}</Typography>
                </Form.Label>
                <Col sm="9">
                  <SelectPersonnel
                    name="exceptions"
                    isMulti={true}
                    defaultValue={holiday ? holiday.exceptions_data : null}
                  />
                </Col>
              </Form.Group>

              {/* Paid Leave */}
              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm="3">
                  <Typography variant="form">{tr("common:breadcrumb.paid-leave")}</Typography>
                </Form.Label>
                <Col sm="9" className="d-flex align-items-center">
                  <Form.Check
                    {...register("reduce_paid_leave")}
                    type="checkbox"
                    label={tr("attendance:reduce_paid_leave_quota")}
                  />
                </Col>
              </Form.Group>

              {/* Action Buttons */}
              <div className="mt-5 d-flex justify-content-between">
                <BackButton url="/attendance?tab=holiday" />
                <Button type="submit" className="btn btn-primary">
                  <FontAwesomeIcon icon={faCheckCircle} />{" "}
                  {isEdit ? tr("attendance:update") : tr("attendance:create")}
                </Button>
              </div>
            </Form>
          </FormProvider>
        </div>
      </Col>
      <Col lg={5}></Col>
    </Row>
  );
};

export default HolidayForm;
